/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ApplyProjectAddonBody,
  ListProjectAddonsResponse
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * Returns the billing addons that are currently applied, including the active compute instance size, and lists every addon option that can be provisioned with pricing metadata.
 * @summary List billing addons and compute instance selections
 */
export type v1ListProjectAddonsResponse200 = {
  data: ListProjectAddonsResponse
  status: 200
}

export type v1ListProjectAddonsResponse401 = {
  data: void
  status: 401
}

export type v1ListProjectAddonsResponse403 = {
  data: void
  status: 403
}

export type v1ListProjectAddonsResponse429 = {
  data: void
  status: 429
}

export type v1ListProjectAddonsResponse500 = {
  data: void
  status: 500
}

export type v1ListProjectAddonsResponseSuccess = (v1ListProjectAddonsResponse200) & {
  headers: Headers;
};
export type v1ListProjectAddonsResponseError = (v1ListProjectAddonsResponse401 | v1ListProjectAddonsResponse403 | v1ListProjectAddonsResponse429 | v1ListProjectAddonsResponse500) & {
  headers: Headers;
};

export type v1ListProjectAddonsResponse = (v1ListProjectAddonsResponseSuccess | v1ListProjectAddonsResponseError)

export const getV1ListProjectAddonsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/billing/addons`
}

export const v1ListProjectAddons = async (ref: string, options?: RequestInit): Promise<v1ListProjectAddonsResponse> => {
  
  return customFetch<v1ListProjectAddonsResponse>(getV1ListProjectAddonsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Selects an addon variant, for example scaling the project’s compute instance up or down, and applies it to the project.
 * @summary Apply or update billing addons, including compute instance size
 */
export type v1ApplyProjectAddonResponse200 = {
  data: void
  status: 200
}

export type v1ApplyProjectAddonResponse401 = {
  data: void
  status: 401
}

export type v1ApplyProjectAddonResponse403 = {
  data: void
  status: 403
}

export type v1ApplyProjectAddonResponse429 = {
  data: void
  status: 429
}

export type v1ApplyProjectAddonResponse500 = {
  data: void
  status: 500
}

export type v1ApplyProjectAddonResponseSuccess = (v1ApplyProjectAddonResponse200) & {
  headers: Headers;
};
export type v1ApplyProjectAddonResponseError = (v1ApplyProjectAddonResponse401 | v1ApplyProjectAddonResponse403 | v1ApplyProjectAddonResponse429 | v1ApplyProjectAddonResponse500) & {
  headers: Headers;
};

export type v1ApplyProjectAddonResponse = (v1ApplyProjectAddonResponseSuccess | v1ApplyProjectAddonResponseError)

export const getV1ApplyProjectAddonUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/billing/addons`
}

export const v1ApplyProjectAddon = async (ref: string,
    applyProjectAddonBody: ApplyProjectAddonBody, options?: RequestInit): Promise<v1ApplyProjectAddonResponse> => {
  
  return customFetch<v1ApplyProjectAddonResponse>(getV1ApplyProjectAddonUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      applyProjectAddonBody,)
  }
);}
  

/**
 * Disables the selected addon variant, including rolling the compute instance back to its previous size.
 * @summary Remove billing addons or revert compute instance sizing
 */
export type v1RemoveProjectAddonResponse200 = {
  data: void
  status: 200
}

export type v1RemoveProjectAddonResponse401 = {
  data: void
  status: 401
}

export type v1RemoveProjectAddonResponse403 = {
  data: void
  status: 403
}

export type v1RemoveProjectAddonResponse429 = {
  data: void
  status: 429
}

export type v1RemoveProjectAddonResponse500 = {
  data: void
  status: 500
}

export type v1RemoveProjectAddonResponseSuccess = (v1RemoveProjectAddonResponse200) & {
  headers: Headers;
};
export type v1RemoveProjectAddonResponseError = (v1RemoveProjectAddonResponse401 | v1RemoveProjectAddonResponse403 | v1RemoveProjectAddonResponse429 | v1RemoveProjectAddonResponse500) & {
  headers: Headers;
};

export type v1RemoveProjectAddonResponse = (v1RemoveProjectAddonResponseSuccess | v1RemoveProjectAddonResponseError)

export const getV1RemoveProjectAddonUrl = (ref: string,
    addonVariant: 'ci_micro' | 'ci_small' | 'ci_medium' | 'ci_large' | 'ci_xlarge' | 'ci_2xlarge' | 'ci_4xlarge' | 'ci_8xlarge' | 'ci_12xlarge' | 'ci_16xlarge' | 'ci_24xlarge' | 'ci_24xlarge_optimized_cpu' | 'ci_24xlarge_optimized_memory' | 'ci_24xlarge_high_memory' | 'ci_48xlarge' | 'ci_48xlarge_optimized_cpu' | 'ci_48xlarge_optimized_memory' | 'ci_48xlarge_high_memory' | 'cd_default' | 'pitr_7' | 'pitr_14' | 'pitr_28' | 'ipv4_default',) => {


  

  return `/v1/projects/${ref}/billing/addons/${addonVariant}`
}

export const v1RemoveProjectAddon = async (ref: string,
    addonVariant: 'ci_micro' | 'ci_small' | 'ci_medium' | 'ci_large' | 'ci_xlarge' | 'ci_2xlarge' | 'ci_4xlarge' | 'ci_8xlarge' | 'ci_12xlarge' | 'ci_16xlarge' | 'ci_24xlarge' | 'ci_24xlarge_optimized_cpu' | 'ci_24xlarge_optimized_memory' | 'ci_24xlarge_high_memory' | 'ci_48xlarge' | 'ci_48xlarge_optimized_cpu' | 'ci_48xlarge_optimized_memory' | 'ci_48xlarge_high_memory' | 'cd_default' | 'pitr_7' | 'pitr_14' | 'pitr_28' | 'ipv4_default', options?: RequestInit): Promise<v1RemoveProjectAddonResponse> => {
  
  return customFetch<v1RemoveProjectAddonResponse>(getV1RemoveProjectAddonUrl(ref,addonVariant),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

